import React, { useMemo } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import { Box } from "@mui/material";

const containerStyle = { width: "100%", height: "100%" };

function getCenter(points) {
  const latSum = points.reduce((sum, p) => sum + parseFloat(p.lat), 0);
  const lngSum = points.reduce((sum, p) => sum + parseFloat(p.lon), 0);
  return {
    lat: latSum / points.length,
    lng: lngSum / points.length,
  };
}

function MapMarkerViewer({ payload }) {
  const markers = useMemo(() => payload, [payload]);
  const center = useMemo(() => getCenter(payload), [payload]);

  return (
    <Box width="100%" height="100%">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={{
          disableDefaultUI: false,
          gestureHandling: "greedy",
        }}
      >
        {markers.map((item, index) => (
          <React.Fragment key={index}>
            <Marker
              position={{
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lon),
              }}
            />
            <OverlayView
              position={{
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lon),
              }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#1A237E",
                  whiteSpace: "nowrap",
                  minWidth: "230px",
                }}
              >
                {`อำเภอ ${item.amphur}, จังหวัด ${item.province}`}
              </div>
            </OverlayView>
          </React.Fragment>
        ))}
      </GoogleMap>
    </Box>
  );
}

export default MapMarkerViewer;
